// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style.css\"","easilBlack":"#2c2e2f","h5":"style_h5__S58EI"};